import { render } from "./AdminRole.vue?vue&type=template&id=5a7cbcc5&scoped=true"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"

import "./AdminRole.vue?vue&type=style&index=0&id=5a7cbcc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7cbcc5"]])

export default __exports__